import React, { useState, useEffect } from "react";
import styles from "./UserDetails.module.scss";
import { Container, Row, Col, Card, Button, Badge, Nav, Tab, Form } from "react-bootstrap";
import { t } from "i18next";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import UserClass from "../../../General/LocalStorage/UserClass";
import DataManager from "../../../General/DataManager";


import UserTabs from "./UserTabs";



const UserDetails = () => {

    const { id } = useParams();


    const [user, setUser] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [limit] = useState(10);
    const [search, setSearch] = useState("");
    const [getUserError, setGetUserError] = useState(null);

    useEffect(() => {
        getUser(id);
    }, []);


    const getUser = async (userId) => {

        let instance = UserClass.getInstance();
        let token = instance.getTokenUser();
        const { data, msgError } = await DataManager.getUser(token, userId);


        if (msgError) {
            setGetUserError(msgError);
            return;
        }
        setUser(data)

    }
    //end



    const navigate = useNavigate();


    const handleCancel = () => {
        navigate("/pages/UserManagement");
    };
    const roleLabels = {
        OPERATOR: t("role_operator"),
        DEVICE_MANAGER: t("role_device_manager"),
        OPERATOR_CHECKIN: t("role_operator_checkin"),
        OPERATOR_SUPERVISOR: t("role_operator_supervisor"),
        SYSADMIN: t("role_sysadmin"),
        BOARDING_OPERATOR: t("role_boarding_operator"),

    };


    return (
        <div className={styles.UserDetails}>
            <Container fluid="md">
                {/* Header */}
                <Row className="mb-4 align-items-center">
                    <Col>
                        <h2 className={styles.title}>
                            {user.firstName} {user.lastName}
                            <Badge bg={user.status === "ACTIVE" ? "success" : "danger"} className="ms-3">
                                {user.status}
                            </Badge>
                        </h2>
                        <div className={styles.subtitle}>{user.username}</div>
                    </Col>
                    <Col xs="auto">
                        <Button variant="secondary" className="me-2" onClick={handleCancel}>
                            {t("cancel")}
                        </Button>
                        <Button className="btn-primary" onClick={() => navigate(`/pages/UserManagement/EditUser/${id}`, {
                            state: {
                                user, assignedPortIds: user?.ports
                            }
                        })
                        }>{t("edit")}</Button>
                    </Col>
                </Row>
                <Tab.Container defaultActiveKey="profile">
                    {/* Tabs */}
                    <UserTabs activeKey="profile" showPermissions={user.role === "BOARDING_OPERATOR"} />


                    {/* Tab Content */}
                    <Tab.Content>
                        {/* PROFILE TAB */}
                        <Tab.Pane eventKey="profile">
                            <Row>
                                <Col md={6}>
                                    <Card className="mb-4">
                                        <Card.Body>
                                            <h5 className="mb-3">{t("basic_information")}</h5>
                                            <div className={styles.field}><span>{t("firstName")}</span><strong>{user?.firstName}</strong></div>
                                            <div className={styles.field}><span>{t("lastName")}</span><strong>{user?.lastName}</strong></div>
                                            <div className={styles.field}><span>{t("email")}</span><strong>{user?.email}</strong></div>
                                            <div className={styles.field}><span>{t("company")}</span><strong>{user?.companies?.join(", ")}</strong></div>
                                            <div className={styles.field}><span>{t("phone")}</span><strong>{user?.phoneNumber}</strong></div>
                                        </Card.Body>
                                    </Card>
                                </Col>

                                <Col md={6}>
                                    <Card className="mb-4">
                                        <Card.Body>
                                            <h5 className="mb-3">{t("account_information")}</h5>
                                            <div className={styles.field}><span>{t("role")}</span><strong>{roleLabels[user?.role]}</strong></div>
                                            <div className={styles.field}><span>{t("status")}</span><strong> {t(`status_${user?.status?.toLowerCase()}`)}</strong></div>
                                            <div className={styles.field}><span>{t("created_at")}</span><strong>{user?.createdAt ? new Date(user?.createdAt)?.toLocaleString("it-IT") : ''}</strong></div>
                                            <div className={styles.field}><span>{t("updated_at")}</span><strong>{user?.updatedAt ? new Date(user?.updatedAt).toLocaleString("it-IT") : ''}</strong></div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </Tab.Pane>

                        <Tab.Pane eventKey="reports">
                            <Card className="shadow-sm">
                                <Card.Body>
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <div>
                                            <h5 className="mb-1">{t("assigned_reports")}</h5>
                                            <small className="text-muted">
                                                {t('reports_description')}
                                            </small>
                                        </div>


                                        <Badge bg="info">
                                            {user.reports?.length} {t("reports")}
                                        </Badge>
                                    </div>
                                    {user.reports?.length > 0 ? (
                                        <Row>
                                            {user.reports?.map((report, index) => (
                                                <Col md={6} lg={4} key={index} className="mb-3">
                                                    <Card className="h-100 border-0 shadow-sm">
                                                        <Card.Body className="d-flex align-items-start">
                                                            <div className="me-3 text-primary fs-4">
                                                                <i className="bi bi-geo-alt-fill" />
                                                            </div>

                                                            <div>
                                                                <div className="fw-semibold">
                                                                    {report?.name}
                                                                </div>
                                                                <small className="text-muted">
                                                                    {t("report_code")}: {report?.name}
                                                                </small>
                                                                <div className="mt-2 ms-1">
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        label={t("default_report_recipient")}
                                                                        checked={report?.defaultSending}
                                                                        className="text-body"
                                                                        disabled
                                                                    />
                                                                </div>
                                                                <div className="mt-2 ms-1">
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        label={t("appear_sending_list")}
                                                                        checked={report?.appearInSendingList}
                                                                        className="text-body"
                                                                        disabled
                                                                    />
                                                                </div>
                                                            </div>
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                            ))}
                                        </Row>
                                    ) : (
                                        <div className="text-center py-4 text-muted">
                                            <i className="bi bi-shield-lock fs-2 mb-2 d-block" />
                                            {t("no_reports_assigned")}
                                        </div>
                                    )}
                                </Card.Body>
                            </Card>
                        </Tab.Pane>

                        {user.role === "BOARDING_OPERATOR" && (<Tab.Pane eventKey="permissions">
                            <Card className="shadow-sm">
                                <Card.Body>
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <div>
                                            <h5 className="mb-1">{t("assigned_access")}</h5>
                                            <small className="text-muted">
                                                {t('assigned_ports_description')}
                                            </small>
                                        </div>

                                        <Badge bg="info">
                                            {user?.ports?.length} {t("ports")}
                                        </Badge>
                                    </div>

                                    {user?.ports?.length > 0 ? (
                                        <Row>
                                            {user?.ports?.map((port, index) => (
                                                <Col md={6} lg={4} key={index} className="mb-3">
                                                    <Card className="h-100 border-0 shadow-sm">
                                                        <Card.Body className="d-flex align-items-start">
                                                            <div className="me-3 text-primary fs-4">
                                                                <i className="bi bi-geo-alt-fill" />
                                                            </div>

                                                            <div>
                                                                <div className="fw-semibold">
                                                                    {port}
                                                                </div>
                                                                <small className="text-muted">
                                                                    {t("port_code")}: {port}
                                                                </small>
                                                            </div>
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                            ))}
                                        </Row>
                                    ) : (
                                        <div className="text-center py-4 text-muted">
                                            <i className="bi bi-shield-lock fs-2 mb-2 d-block" />
                                            {t("no_ports_assigned")}
                                        </div>
                                    )}
                                </Card.Body>
                            </Card>
                        </Tab.Pane>)}

                    </Tab.Content>
                </Tab.Container>
            </Container>
        </div>
    );
};

export default UserDetails;